import { axios, serializeParams } from '@/lib/helpers';
import { createAction } from '@reduxjs/toolkit';

export const setProducts = createAction('products/set');
export const setLastVisitedProduct = createAction('products/last-visited/set');

export const fetchProductsStarted = createAction('products/fetch/started');
export const fetchProductsSucceeded = createAction('products/fetch/succeeded');
export const fetchProductsFailed = createAction('products/fetch/failed');

export const fetchProducts = (searchFilters, searchOperator) => (dispatch, getState) => {
  const state = getState();
  const userState = state.user;
  let { user, chainUrls } = userState;
  const productsSearchState = state.productsSearch;
  let { activeFilters, activeOperator } = productsSearchState;
  const productListColumnsState = state.productListColumns;
  let { activeColumns } = productListColumnsState;

  if (!searchFilters) {
    searchFilters = activeFilters;
  }

  if (!searchOperator) {
    searchOperator = activeOperator;
  }

  dispatch(fetchProductsStarted());

  const requestParams = Object.keys(searchFilters).reduce((acc, key) => {
    const searchFilter = searchFilters[key];
    acc[searchFilter.filterType] = {
      operator: searchFilter.filterOperation,
      value: encodeURIComponent(searchFilter.filterValue),
      useOr: searchFilter.filterUseOr || '0',
    };
    return acc;
  }, {});

  requestParams.activeColumns = activeColumns.map((column) => column.id);

  return axios({
    method: 'get',
    crossdomain: true,
    params: requestParams,
    paramsSerializer: serializeParams,
    url: `${chainUrls.GET_PRODUCTS}searchOperator=${searchOperator}&userId=${user.uuid}`,
  }).then(
    ({ data }) => dispatch(fetchProductsSucceeded(data.result)),
    ({ message }) => dispatch(fetchProductsFailed(message))
  );
};

export const updateProductsStarted = createAction('products/update/started');
export const updateProductsSucceeded = createAction('products/update/succeeded');
export const updateProductsFailed = createAction('products/update/failed');
export const updateProducts = (productUuids, updateData) => (dispatch, getState) => {
  dispatch(updateProductsStarted());

  const state = getState();
  const userState = state.user;
  let { chainUrls } = userState;
  const productsSearchState = state.productsSearch;
  let { activeFilters, activeOperator } = productsSearchState;

  return axios({
    method: 'post',
    data: { ...updateData, productUuids },
    url: `${chainUrls.EDIT_PRODUCTS}`,
  }).then(
    ({ data }) => {
      dispatch(updateProductsSucceeded(data.result));
      dispatch(fetchProducts(activeFilters, activeOperator));
    },
    ({ message }) => dispatch(updateProductsFailed(message))
  );
};
